import { z } from 'zod';
import { USER_ROLES } from '../enums.js';
import { nonEmptyString, paginationSchema } from './common.js';
/** The GitLab username: the account is taken over by the GitLab sign-in under it. */
export const loginNameSchema = z
    .string({ required_error: 'Login is required' })
    .trim()
    .min(3, 'Login must be at least 3 characters')
    .max(64, 'Login must be at most 64 characters')
    .regex(/^[a-zA-Z0-9._-]+$/, 'Login may contain letters, digits, dot, underscore and hyphen');
/**
 * Access granted ahead of the first sign-in, by GitLab username. Without a name
 * the login stands in until the GitLab sign-in brings the real one.
 */
export const createUserSchema = z.object({
    login: loginNameSchema,
    name: z
        .string()
        .trim()
        .max(120, 'Name must be at most 120 characters')
        .optional()
        .transform((value) => value || undefined),
    role: z.enum(USER_ROLES).default('qa_engineer'),
});
export const updateUserSchema = z
    .object({
    name: nonEmptyString(120, 'Name').optional(),
    role: z.enum(USER_ROLES).optional(),
    isActive: z.boolean().optional(),
})
    .refine((value) => Object.keys(value).length > 0, { message: 'Nothing to update' });
export const listUsersSchema = paginationSchema.extend({
    /** Part of the GitLab login or of the name. */
    q: z.string().trim().max(64).optional(),
    role: z.enum(USER_ROLES).optional(),
    includeInactive: z.coerce.boolean().default(false),
});
//# sourceMappingURL=user.js.map